import { createRoot } from 'react-dom/client';
import Markdown, { type Components } from 'react-markdown';

// Renders the markdown-supported campaign pageTitle into the page's <h1>.
//
// react-markdown wraps top-level text in a <p>; map the paragraph to a fragment so the title
// (including any **bold** -> <strong>) renders inline inside the heading rather than as a block.
const components: Components = {
    p: ({ children }) => <>{children}</>,
};

document.addEventListener('DOMContentLoaded', () => {
    const dataElement = document.getElementById('js-page-title-data');
    const mount = document.getElementById('campaign-title');
    if (!dataElement || !mount) {
        return;
    }

    const pageTitle = dataElement.textContent?.trim() ?? '';
    const root = createRoot(mount);
    root.render(<Markdown components={components}>{pageTitle}</Markdown>);
});
